import { render, staticRenderFns } from "./notifications-list2.vue?vue&type=template&id=c387a08c&"
import script from "./notifications-list2.vue?vue&type=script&lang=js&"
export * from "./notifications-list2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports